import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import FilterMint from "../filters/FilterMint.vue";
import FilterNumber from "../filters/FilterNumber.vue";
import {EFilterOperatorsChange, EFilterOperatorsParity, FilterOperatorsBitmap, getFiltersByKey, ISignalFilters} from "@/shared";
import FilterOperators from "../filters/FilterOperators.vue";
import FiltersGeneric from "@/components/automation/filters/FiltersGeneric.vue";

// props
interface IProps {
	data?: any;
	filters?: ISignalFilters;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignalIndicatorBO',
  props: {
    data: null,
    filters: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	data?: any;
	filters?: ISignalFilters;
};




const _availableFilters = [
	{key: "upper", name: "Upper Band", operator: 2, type: "uint64", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsChange)},
	{key: "middle", name: "Middle Band", operator: 2, type: "uint64", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsChange)},
	{key: "lower", name: "Lower Band", operator: 2, type: "uint64", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsChange)},
]


const isInvalid = computed<boolean>(
	() => {
		for (let i = 0; i < FilterGenericRef.value?.data.length; i++) {
			if (!FilterGenericRef.value?.data[i]?.value || FilterGenericRef.value?.data[i]?.value === 0) return true
		}
		return false

	});

const getData = computed<any>(() => {
	return {
		mint: mint.value,
		filters: FilterGenericRef.value?.data,
	};
});

// methods

// data
const FilterGenericRef = ref<InstanceType<typeof FiltersGeneric> | null>(null);

const mint = ref<string>(props.data?.mint ?? "");

// expose
expose({isInvalid, data: getData});

return { __sfc: true,props, _availableFilters, isInvalid, getData, FilterGenericRef, mint, FilterMint, FiltersGeneric }
}

})